import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "base_manager"
};
const _hoisted_2 = {
  class: "base_screen_header"
};

const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, null, -1);

import DataCollectTable from '@com/table/DataCollectTable.vue';
import { OP_KEY, OPERATIONS, operationsHander } from "@com/table/tableOperations";
import { ref, reactive } from 'vue';
import $ from "@util/base";
import { $msg, $box } from "@ui/msg";
import { Search } from '@element-plus/icons-vue';
import useRoute from "@util/router";
import api from "@api/finance";
export default {
  __name: 'BaseManager',

  setup(__props) {
    const route = useRoute();
    route.watchRouter('basemanager2', () => {
      getBaseList();
    });
    const name = ref(route.query().name || '');

    function searchName(val) {
      route.replaceQuery('name', val);
    }

    const data = ref([]);
    const total = ref(0);

    function roleOperations() {
      return [OPERATIONS.check];
    }

    const config = {
      showIndex: true,
      operations: {
        label: '操作',
        width: 120,
        operations: roleOperations
      },
      column: [{
        label: '基地名称',
        prop: 'name',
        width: 180
      }, {
        label: '收款金额（元）',
        prop: 'dueMoney'
      }, {
        label: '单数（笔）',
        prop: 'payNum',
        width: 100
      }, {
        label: '退款金额（元）',
        prop: 'refundMoney',
        width: 130
      }]
    };
    const opHander = operationsHander();
    opHander.install(OP_KEY.check, data => {
      route.push({
        name: 'overview',
        query: {
          base: data.code
        }
      });
    });
    getBaseList();

    function getBaseList() {
      let routeQuery = route.query();
      api.baseList(routeQuery.name, routeQuery.p, routeQuery.s, val => {
        total.value = val.total;
        data.value = val.itemList;
      });
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_main = _resolveComponent("el-main");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_main, {
        class: "base_main_content"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_el_form, {
          inline: true,
          class: "base_search_form",
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: name.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => name.value = $event),
              "onKeyup[native]": searchName,
              onChange: searchName,
              placeholder: "基地名称",
              clearable: "",
              "suffix-icon": _unref(Search)
            }, null, 8, ["modelValue", "suffix-icon"])]),
            _: 1
          })]),
          _: 1
        })]), _createVNode(DataCollectTable, {
          data: data.value,
          total: total.value,
          config: config,
          onOperationsHander: _unref(opHander).receive
        }, null, 8, ["data", "total", "onOperationsHander"])]),
        _: 1
      })]);
    };
  }

};